import React, { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import BaseFilter, {
  FilterTypeEnum,
} from '../../../components/base/BaseFilter';
import { ArrayStringData } from '../../../utils';

function Filter({
  subCategoryList,
  brandList,
  backAction = () => {}
}) {
  const location = useLocation();
  const dispatch = useDispatch();

  const parsedSearch = queryString.parse(location.search);
  const searchSubcategory = parsedSearch['subcategory'] || '';
  const searchBrand = parsedSearch['brand'] || '';

  const [subcategory, setSubcategory] = useState(
    ArrayStringData(searchSubcategory)
  );
  const [brand, setBrand] = useState(
    ArrayStringData(searchBrand)
  );

  // useEffect(() => {
  //   dispatch(createAction('storeCategoryList/getAllStoreSubcategoryList')({}));
  // }, [dispatch]);

  const content = [
    {
      title: 'Subcategory',
      data: subCategoryList,
      value: subcategory,
      setValue: setSubcategory,
      componment: FilterTypeEnum.choice,
    },
    {
      title: 'Brand',
      data: brandList,
      value: brand,
      setValue: setBrand,
      componment: FilterTypeEnum.choice,
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

const mapPropsToState = (state) => ({
  subCategoryList: state.storeCategoryList.subCategoryList,
  brandList: state.brand.brandList,
});

export default connect(mapPropsToState)(Filter);
